/** Marketing / ads consent helpers (localStorage). */

const STORAGE_KEY = "beyundai_marketing_consent";

export function getMarketingConsent() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "accepted") return "accepted";
    if (v === "declined") return "declined";
  } catch {
    /* ignore */
  }
  return "unknown";
}

export function setMarketingConsent(value) {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    /* ignore */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("beyundai:marketing-consent", { detail: value }),
    );
  }
}

export function hasAcceptedMarketingConsent() {
  return getMarketingConsent() === "accepted";
}
